import defaultLocales from 'globals/locales/default';
import { FsUserDetailsFormProps } from 'ui-elements/forms/FsUserDetailsForm/FsUserDetailsForm';
import {
  PasswordUpdateObject,
  PasswordUpdateProps,
} from './PasswordUpdate/PasswordUpdate';

export const userDetailsProps: FsUserDetailsFormProps = {
  title: defaultLocales.userDetails,
};

const passwordUpdateObject: PasswordUpdateObject = {
  currentPassword: '',
  newPassword: '',
  repeatNewPassword: '',
};

export const passwordUpdateProps: PasswordUpdateProps = {
  title: defaultLocales.updatePassword,
  data: passwordUpdateObject,
};
